import { ConfigMessagesViewer } from '../components/ConfigMessagesViewer'
import { useAccountContext } from '../contexts'
import { Layout } from '../layouts/Layout'

export function ConfigMessagesPage() {
  const { selectedDevice } = useAccountContext()

  return (
    <Layout>
      <ConfigMessagesViewer sigfoxId={selectedDevice} />
    </Layout>
  )
}
